import React, { useEffect, useState } from 'react';
import { useGetPageContentQuery, useGetAvailableContentTypesQuery, useUpdatePageContentMutation, useGetAvailableItemsQuery, useGetAvailablePagesQuery } from '../../redux/api/pageContent';
import { Select, Input, Button } from 'antd';
import { useSelector } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';

const PageContentSettingsPage = () => {

    const [selectedPage, setSelectedPage] = useState();
    const [selectedContentType, setSelectedContentType] = useState();
    const [selectedItem, setSelectedItem] = useState();
    const [selectedSpan, setSelectedSpan] = useState();
    const [selectedIndex, setSelectedIndex] = useState();
    const [selectedPageRowData, setSelectedPageRowData] = useState();
    const [selectedPageColumnDefs, setSelectedPageColumnDefs] = useState();

    const selectedClientName = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);

    const availablePages = useGetAvailablePagesQuery();
    const availableContentTypes = useGetAvailableContentTypesQuery();
    const availableItems = useGetAvailableItemsQuery({ contentType: selectedContentType });
    const pageContent = useGetPageContentQuery({ clientName: selectedClientName, pageName: selectedPage });
    const [updatePageContent] = useUpdatePageContentMutation();


    useEffect(() => {
        if (pageContent.data) {
            setSelectedPageRowData(pageContent.data['content']);
            var columnDefs = [];
            columnDefs = Object.keys(pageContent.data['content'][0]).map((key) => ({
                headerName: key.replace(/_/g, " ").toUpperCase(), // Make headers more readable
                field: key,
            }));
            setSelectedPageColumnDefs(columnDefs);
        }
    }, [pageContent]);

    function addPageContent() {
        // replace the item at the selected index with the new item
        var rowData = [...selectedPageRowData];
        var newRow = {
            'content_type': selectedContentType,
            'content_name': selectedItem,
            'content_span': parseInt(selectedSpan, 10),
            'content_index': parseInt(selectedIndex, 10),
        }
        console.log(selectedIndex);
        console.log(newRow);
        rowData.splice(selectedIndex, 1, newRow);
        setSelectedPageRowData(rowData);

    }

    return (
        <div>
            <div>
                <Select
                    style={{
                        width: '10vw',
                        margin: '0 8px',
                    }}
                    placeholder="Select a page"
                    onChange={(value) => setSelectedPage(value)}
                    value={selectedPage}
                >
                    {availablePages.data && availablePages.data.map((page) => (
                        <Select.Option key={page} value={page}>{page}</Select.Option>
                    ))}
                </Select>
                <Select
                    style={{
                        width: '10vw',
                        margin: '0 8px',
                    }}
                    placeholder="Select a content type"
                    onChange={(value) => setSelectedContentType(value)}
                    value={selectedContentType}
                >
                    {availableContentTypes.data && availableContentTypes.data.map((contentType) => (
                        <Select.Option key={contentType} value={contentType}>{contentType}</Select.Option>
                    ))}
                </Select>
                <Select
                    style={{
                        width: '10vw',
                        margin: '0 8px',
                    }}
                    placeholder="Select an item"
                    onChange={(value) => setSelectedItem(value)}
                    value={selectedItem}
                >
                    {availableItems.data && availableItems.data.map((item) => (
                        <Select.Option key={item} value={item}>{item}</Select.Option>
                    ))}
                </Select>
                <Input
                    style={{
                        width: '10vw',
                        margin: '0 8px',
                    }}
                    type="number"
                    min={0}
                    max={24}
                    placeholder="Enter a span"
                    onChange={(e) => setSelectedSpan(e.target.value)}
                    value={selectedSpan}
                />
                <Input
                    style={{
                        width: '10vw',
                        margin: '0 8px',
                    }}
                    type="number"
                    min={0}
                    max={100}
                    placeholder="Enter an index"
                    onChange={(e) => setSelectedIndex(e.target.value)}
                    value={selectedIndex}
                />
                <Button onClick={addPageContent}>
                    Add
                </Button>
            </div>
            <div style={{
                height: '50vh',
                width: '80vw',
                margin: '2vh',
            }}>
                <AgGridReact
                    columnDefs={selectedPageColumnDefs}
                    rowData={selectedPageRowData}
                    pagination={true}
                    paginationPageSize={30}
                />
            </div>
            <Button onClick={() => {
                updatePageContent({
                    clientName: selectedClientName,
                    pageName: selectedPage,
                    content: selectedPageRowData,
                });
            }} style={{
                'margin': '2vh',
                'width': '30vw',
            }}>Update Page Content</Button>
        </div>
    );
};

export default PageContentSettingsPage;